import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import LeftBar from "../components/common/LeftBar";
import NewHeader from "../components/common/NewHeader";
import { checkRouteIsExcluded } from "../routes-with-no-layout";

export default function Layout({ children }) {
    const location = useLocation();
    const[lookerEnabled,setLookerEnabled]=useState(undefined)
    const routesWithNoLayout = checkRouteIsExcluded(location.pathname);
          const USER_TOKEN = window.localStorage.getItem("user_token");

    return routesWithNoLayout ? (
        <>
            {routesWithNoLayout.showHeader && <NewHeader />}
            {children}
        </>
    ) : (
        <LeftBar  showHeader>{children}</LeftBar>
    );
}
